export const GET_NOTIFICATION_LIST = "notification/getNotificationList";
export const CREATE_NOTIFICATION = "notification/createNotification";
export const SET_READ_NOTIFICATION = "notification/setReadNotification";
export const GET_MORE_NOTIFICATION = "notification/getMoreNotification";
export const GET_NEW_NOTIFICATION = "notification/getNewNotification";
export const SET_NEW_NOTIFICATION_VISIBLE = "notification/setNewNotificationVisible";
